import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bda289a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-4 shadow p-4 p-lg-5 mb-4 pt-lg-3"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "d-flex flex-lg-row flex-column justify-content-between align-items-lg-center align-items-start mb-2 mb-lg-0" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative" }
const _hoisted_5 = {
  key: 0,
  class: "read"
}
const _hoisted_6 = { class: "fs-7 d-flex justify-content-end" }
const _hoisted_7 = { class: "mt-3 text-break" }
const _hoisted_8 = {
  key: 0,
  class: "mt-3 text-break"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip" }, null, -1))
const _hoisted_10 = {
  key: 2,
  class: "text-center fw-bold fs-4 mt-5"
}

import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import Title from '@/components/title/index.vue'
import { CONVERSATIONS_STORE } from '@/store/constants'
import { translate } from '@/languages/i18n'
import MessageDetail from './detail-subject/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import PostSkeleton from '@/components/skeletons/PostSkeleton.vue'
import { ChangeTime } from '@/constants/datepicker.ts'

//TODO: SS10

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()

const inforDetail = ref<{ id: number | string; tag: string; invitationGroup: boolean }>({ id: '', tag: '', invitationGroup: false })
const messagesData = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.MESSAGES_DATA])

onMounted(() => {
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_MESSAGES_DATA, { id: router.currentRoute.value?.params?.id })
})

const handleDetailMessage = (id: string | number, tag: string, invitationGroup: boolean) => {
  inforDetail.value = {
    id,
    tag,
    invitationGroup,
  }
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.UPDATE_LIST_MESSAGES, { id, tag })
}

const messageTag = (status: any) => {
  if (status === 'yelloop') {
    return {
      type: 'yelloop',
      fileType: 'yelloop_message',
      name: 'YELLoop',
    }
  }
  if (status === 'community') {
    return {
      type: 'community_admin',
      fileType: 'community_message',
      name: '運営事務局',
    }
  }
  return
}

return (_ctx: any,_cache: any) => {
  const _component_h7 = _resolveComponent("h7")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, {
      title: _unref(translate)('message'),
      className: 'fw-bolder'
    }, null, 8, ["title"]),
    (!_unref(messagesData)?.loadingData && _unref(messagesData)?.messages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messagesData)?.messages, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: "py-4 cursor-pointer border-bottom",
              "data-bs-toggle": "modal",
              "data-bs-target": "#detailMessage",
              onClick: ($event: any) => (handleDetailMessage(item.id, item?.message_tag, item?.invitation_group))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (!item?.read)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                    : _createCommentVNode("", true),
                  _createVNode(UserAliasIcon, {
                    userType: messageTag(item?.message_tag)?.type
                  }, null, 8, ["userType"]),
                  _createVNode(_component_h7, {
                    class: _normalizeClass(['fw-bold', item?.message_tag === 'yelloop' ? 'subject-yelloop' : 'text-black'])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item?.message_tag === 'community' ? item?.operating_name : messageTag(item?.message_tag).name), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(ChangeTime)(item.booking_date)), 1)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.subject), 1),
              (item.has_attached_files)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('attached')), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(messagesData)?.loadingData)
      ? (_openBlock(), _createBlock(PostSkeleton, { key: 1 }))
      : _createCommentVNode("", true),
    (!_unref(messagesData)?.loadingData && !_unref(messagesData)?.messages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(translate)('SS10noMessage')), 1))
      : _createCommentVNode("", true),
    _createVNode(MessageDetail, {
      messageData: inforDetail.value,
      messageTag: messageTag
    }, null, 8, ["messageData"])
  ], 64))
}
}

})